import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileSafetyConfirmRegisterState {
  /** 安否確認名 */
  name: string;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileSafetyConfirmRegister store
 *
 * - store
 *   - 安否確認新規作成画面の入力情報を保持する
 * - action, mutation
 *   - 安否確認新規作成画面の入力情報を格納する
 */
@Module({ name: "mobileSafetyConfirmRegister" })
export default class MobileSafetyConfirmRegister extends VuexModule implements MobileSafetyConfirmRegisterState {
  name = "";
  exist = false;

  /** stateのgetters */
  get mobileSafetyConfirmRegisterState(): MobileSafetyConfirmRegisterState {
    const state: MobileSafetyConfirmRegisterState = {
      name: this.name,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_SAFETY_CONFIRM_REGISTER_STATE(state: MobileSafetyConfirmRegisterState) {
    this.name = state.name;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_SAFETY_CONFIRM_REGISTER_STATE() {
    this.name = "";
    this.exist = false;
    return;
  }

  /**
   * ### 安否確認新規作成画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileSafetyConfirmRegisterState(payload: { state: MobileSafetyConfirmRegisterState }): void {
    this.SET_MOBILE_SAFETY_CONFIRM_REGISTER_STATE(payload.state);
    return;
  }

  /**
   * ### 安否確認新規作成画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileSafetyConfirmRegisterState(): void {
    this.RESET_MOBILE_SAFETY_CONFIRM_REGISTER_STATE();
    return;
  }
}
